<template>
  <div class="page login-validate">
    <navigation :customClickEvent="true" @click="detention"></navigation>
    <img
      class="logo"
      src="./images/logo.png"
      srcset="./images/logo@2x.png 2x, ./images/logo@3x.png 3x"
    />

    <div class="login-title">
      验证码校验
    </div>

    <form class="form" ref="form" onsubmit="return false;">
      <div class="form-item underline-un-focus code">
        <nd-input
          v-model="form.smsCode"
          name="smsCode"
          type="pure-number"
          maxLength="6"
          placeholder="请输入验证码"
          @blur="codeBlur"
          @focus="codeFocus"
        >
        </nd-input>
      </div>
      <p class="error-tip error" v-if="errorTip">{{ errorTip }}</p>
      <nd-send-code
        fmt="已发送(ms)"
        ref="smsCode"
        class="send-code"
        :sendCode="sendCodeHandler"
        v-if="showSendCode"
      />
    </form>

    <nd-button class="btn" :disabled="isDisabled" @click="login">确认</nd-button>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import validate from '../../components/nd-validate'
import { getKey } from '@/assets/utils'

export default {
  name: 'login-validate',

  data () {
    return {
      form: {
        mobile: this.$route.query.mobile,
        smsCode: '',
        smsKey: ''
      },
      rules: {
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      isDisabled: true,
      errorTip: ''
    }
  },

  mounted () {
    if (this.$route.query.mobile.length === 11) {
      this.$refs['smsCode'].clickHandler()
    }
  },

  mixins: [validate],

  computed: {
    showSendCode () {
      return this.validateWithoutTip({ mobile: this.form.mobile })
    }
  },

  methods: {
    ...mapActions('user', [
      'sendCodeX',
      'loginBySmsX',
      'submitDeviceInfoX',
      'getIRR24'
    ]),
    ...mapMutations('user', ['setUserInfo']),
    detention () {
      this.$router.push({
        path: '/user/login',
        query: {
          selected: 'T'
        }
      })
    },
    async sendCodeHandler () {
      const response = await this.sendCodeX({
        mobile: this.form.mobile
      })
      if (response.success) {
        this.form.smsKey = response.data.smsKey
        this.errorTip = ''
        return true
      }
      return false
    },

    async login () {
      this.$report({
        id: 10020
      })
      const response = await this.loginBySmsX(this.form)
      if (response.success) {
        this.setUserInfo(response.data)
        const { mobile, userId, bindWechat } = response.data
        sessionStorage.removeItem('showDot') // 每次登录重置发现页的小红点
        this.$sensors.login(userId)
        this.$sensors.registerPage({
          gid: getKey('gid'),
          phone_number: mobile
        })
        await this.getIRR24()
        if (this.$route.query.from) {
          return this.$router.push(decodeURIComponent(this.$route.query.from))
        }

        if (!bindWechat) {
          return this.$router.push('/user/wechat/bind')
        }

        // 当从其他页面未登录跳转到登录 登录成功之后直接跳到该页面
        const stroeUrl = sessionStorage.getItem('storeUrl')
        if (stroeUrl && !stroeUrl.includes('/user/login')) {
          sessionStorage.removeItem('storeUrl')
          window.location.href = stroeUrl
        } else if (window.location.href.includes('lyf.lxhua.com.cn')) {
          this.$router.push('/vip/index')
        } else {
          // this.$router.push('/middle/sms_link_bridge')
          this.$router.push('/')
        }
        this.$nextTick(() => {
          this.riskReport(1, {
            mobile: this.form.mobile
          })
        })
        this.$report({
          id: 10021,
          args: { succeed: 1, position: 'page_login_code' }
        })
        this.$statistics('LOGIN')
      } else {
        this.errorTip = response.msg
        this.$report({
          id: 10021,
          args: { succeed: 0, position: 'page_login_code' }
        })
      }
    },

    codeFocus () {
      this.$report({
        id: 10111,
        args: {
          status: 1
        }
      })
    },

    codeBlur () {
      this.$report({
        id: 10111,
        args: {
          status: 0
        }
      })
      if (this.form.smsCode) {
        const isPass = this.validateWithoutTip(this.rules)
        this.$report({
          id: 10070,
          args: {
            status: isPass ? 1 : 0
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.page.login-validate {
    .logo {
        display: block;
        width: 140px;
        height: 140px;
        margin: 140px auto 50px;
    }
    .login-title {
        text-align: center;
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 53px;
    }

    .form {
        position: relative;
        padding: 0 50px;
        margin-top: 93px;

        .form-item {
            &.code {
                .nd-input {
                    margin-right: 160px;
                    width: unset;
                }
            }

            .nd-input {
                margin-bottom: 8px;
            }
        }
        .send-code {
            width: 150px;
            border-radius: 28px;
            bottom: 18px;
            right: 50px;
            position: absolute;

            span {
                display: block;
                font-size: 22px;
            }
        }

        .error-tip {
            font-size: 24px;
            height: 33px;
            line-height: 33px;
            bottom: -50px;
            position: absolute;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }
    }

    .btn {
        margin: 0 auto;
        margin-top: 120px;
    }
}
</style>
